/* Elite sales bar + live counter: when a bar scrolls into view it fills to its real share and the
   number counts up to the real count. Markup: snippets/elite-sold-bar.liquid. Styles: assets/elite-sold.css. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function countUp(el) {
    var end = parseInt(el.getAttribute('data-el-count'), 10);
    if (!isFinite(end)) return;
    if (reduce || end < 3) { el.textContent = String(end); return; }
    var dur = Math.min(1400, 500 + end * 4);
    var t0 = null;
    el.textContent = '0';
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      el.textContent = String(Math.round(ease(p) * end));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function reveal(box) {
    if (box.classList.contains('is-in')) return;
    box.classList.add('is-in');
    var nums = box.querySelectorAll('[data-el-count]');
    for (var i = 0; i < nums.length; i++) countUp(nums[i]);
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { reveal(entries[i].target); io.unobserve(entries[i].target); }
        }
      }, { threshold: 0.35 })
    : null;

  function arm() {
    var boxes = document.querySelectorAll('[data-el-sold]:not(.is-armed)');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].classList.add('is-armed');
      if (io) io.observe(boxes[i]); else reveal(boxes[i]);
    }
  }

  arm();
  /* Cards that arrive later (filters, section re-renders). */
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; arm(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
